export default "__VITE_ASSET__CkO8p4$1__"